import React from "react";
import "swiper/dist/css/swiper.min.css";
import "../../pages/index.styl";
import Accordion from "../Accordion/Accordion";

import cn from "classnames";
import { single } from "../Accordion/shared";
import noMap from "../../images/no-map.jpg";

class TourDisplay extends React.Component {
  state = {
    items: null,
    topLine: null,
    small: null,
    title: null,
    activeTour: null,
    groupTitle: null,
    images: null,
    optionsText: ""
  };

  constructor({ items, topLine, small, images, text }) {
    super();
    this.state.items = items;
    this.state.topLine = topLine;
    this.state.small = small;
    this.state.groupTitle = items[0].title;
    this.state.activeTour = items[0].tours[0];
    this.state.images = images;
    this.state.optionsText = text;
  }

  handleUpdate = (tourTitle, groupTitle) => {
    var i, j, k, y;
    var tourReturn = null;
    for (i = 0, j = this.state.items.length; i < j; i++) {
      if (this.state.items[i].title == groupTitle) {
        for (k = 0, y = this.state.items[i].tours.length; k < y; k++) {
          if (this.state.items[i].tours[k].title == tourTitle) {
            tourReturn = this.state.items[i].tours[k];
          }
        }
      }
    }

    this.setState({
      groupTitle: groupTitle,
      activeTour: tourReturn
    });
  };

  isActive = title => {
    return this.state.activeTour.title == title;
  };

  getActiveTour = (groupTitle, tourTitle) => {
    var i, j, k, y;
    var tourReturn = null;
    for (i = 0, j = this.state.items.length; i < j; i++) {
      if (this.state.items[i].title == groupTitle) {
        for (k = 0, y = this.state.items[i].tours.length; k < y; k++) {
          if (this.state.items[i].tours[k].title == tourTitle) {
            tourReturn = this.state.items[i].tours[k];
          }
        }
      }
    }
  };

  renderTourSelector = (data, title) => {
    var tours = [];
    var i,
      j,
      temparray,
      chunk = Math.ceil(data.length / 3);

      if (chunk < 5){
        chunk = 5
      }
      
    for (i = 0, j = data.length; i < j; i += chunk) {
      temparray = data.slice(i, i + chunk);
      var tourTitles = temparray.map((tour, tourKey) => (
        <li key={tour.title} style={{width: '30'}}>
          <button
            onClick={event => {
              this.handleUpdate(tour.title, title);
            }}
            className={this.isActive(tour.title) ? "is-active" : ""}
          >
            {tour.title}
          </button>
        </li>
      ));
      tours.push(tourTitles);
    }

    var groups = tours.map((group, groupKey) => (
      <ul key={groupKey} className="c-routes__list" >
        {group}
      </ul>
    ));
    return <div className="c-routes" >{groups}</div>;
  };

  renderTourHighlights = () => {
    if ("highlights" in this.state.activeTour) {
      return (
        <div>
          <h3 className="t-h2 t-italic">Tour Highlights Inclusions:</h3>
          <div className="c-ws__lists mt20">
            <ul className="t-ul">
              {this.state.activeTour.highlights.map(
                (highlight, highlightKey) => (
                  <li key={highlightKey}>{highlight}</li>
                )
              )}
            </ul>
            {/**

        
        <ul className="t-ul">
          <li>Guided tour of Grand Canyon National Park</li>
          <li>Grand Canyon Picnic Lunch</li>
          <li>
            Ride the Grand Canyon Railway to Williams on
            Historic Route 66
          </li>
          <li>Comprehensive city tour of Los Angeles</li>
          <li>Las Vegas Night Tour</li>
          <li>Free time to explore</li>
          <li>2 Lunches, 3 Dinners</li>
        </ul>
        */}
          </div>
        </div>
      );
    }
  };

  renderTourOptionals = () => {
    if ("optionals" in this.state.activeTour) {
      return (
        <div>
          <h3 className="t-h2 t-italic">Optional Experiences:</h3>
          <ul className="t-ul mt20">
            {this.state.activeTour.optionals.map((optional, optionalKey) => (
              <li key={optionalKey}>{optional}</li>
            ))}
          </ul>
        </div>
      );
    }
  };

  getHeroImage = () => {
    console.log(this.state.activeTour.hero);
    if (this.state.activeTour.hero != null) {
      return this.state.activeTour.hero;
    } else {
      return noMap;
    }
  };

  render() {
    return (
      <div className="c-golden t-context--light">
        <div
          className="c-golden__short"
          style={{ display: "flex", flexDirection: "column", backgroundColor: "#eaebec" }}
        >
          <div
            className="c-golden__content"
            style={{ backgroundColor: "#eaebec" }}
          >
            <h1 className="t-h1 mb30">{this.state.optionsText}</h1>

            <Accordion stateReducer={single}>
              {({ openIndexes, handleItemClick }) => (
                <div
                  className={cn("c-accordion", {
                    "c-accordion--top-line": this.state.topLine,
                    "c-accordion--small": this.state.small
                  })}
                >
                  {this.state.items.map((item, index) => (
                    <div
                      key={item.title}
                      className={cn("c-accordion__item", {
                        "is-open": openIndexes.indexOf(index) >= 0
                      })}
                    >
                      <div
                        className="c-accordion__btn t-h2"
                        onClick={() => handleItemClick(index)}
                      >
                        {item.title}
                      </div>
                      <div className="c-accordion__contents">
                        {this.renderTourSelector(item.tours, item.title)}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Accordion>
          </div>
          <div
            className="c-golden__images c-golden__short min-laptop"
            style={{ flex: "1" }}
          >
            <img
              src={this.state.images[0]}
              alt=""
              style={{ width: "50%" }}
            />
            <img
              src={this.state.images[1]}
              alt=""
              style={{ width: "50%" }}
            />
            <img
              src={this.state.images[2]}
              alt=""
              style={{ width: "100%" }}
            />
          </div>
        </div>
        <div className="c-golden__wide">
          <img
            src={this.getHeroImage()}
            alt=""
            style={{
              display: "block",
              width: "100%"
              // height: '100%',
              // objectFit: 'cover',
            }}
          />
          <div className="c-golden__content c-golden__wide">
            <div className="c-golden__text">
              <div className="c-golden__text-col">
                <div className="t-map-label mb20">{this.state.groupTitle}</div>
                <h1 className="t-h1">{this.state.activeTour.title}</h1>
                <div className="c-ws__header mt20">
                  <h2 className="t-h2 t-red">
                    {this.state.activeTour.header.days} Days /{" "}
                    {this.state.activeTour.header.nights} Nights
                    <small className="t-small">
                      &nbsp;{this.state.activeTour.header.breakfastText}
                    </small>
                  </h2>
                  <p className="t-h3 t-bold">
                    Begins in {this.state.activeTour.header.start} and ends in{" "}
                    {this.state.activeTour.header.end}
                  </p>
                </div>
                <p className="tour_body mt30">
                  {this.state.activeTour.body}
                </p>
                <div className="c-ws__content mt20">
                  {this.renderTourHighlights()}
                  {this.renderTourOptionals()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TourDisplay;



// WEBPACK FOOTER //
// ./src/components/TourDisplay/TourDisplay.js